import Vue from "vue";
import Router from "vue-router";
// import store from '@/store'
import {request} from '../utils/request'

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/query"
        },
        //查询
        {
            path: "/query",
            component: () => import("@/views/query/query"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },
        //报名须知
        {
            path: "/home",
            component: () => import("@/views/home/home"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },
        //信息详情
        {
            path: "/info",
            component: () => import("@/views/info/info"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },
        //填写信息
        {
            path: "/enter",
            component: () => import("@/views/enter/enter"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },
        //报名成功
        {
            path: "/success",
            component: () => import("@/views/success/success"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },
        //报名暂停
        {
            path: "/pause",
            component: () => import("@/views/pause/pause"),
            meta: {
                title: "日照航海工程职业学院",
                // 缓存首页
                // keepAlive: true
            }
        },

    ]
});
router.beforeEach((to, from, next) => {
    let {title} = to.meta;
    console.log('document', document);
    document.title = title;
    next()
    request('get', 'sitestatus', {}).then((res) => {
        console.log('res', res);
        let status = res.data;
        if ((to.path != '/query' && to.path != '/info') && status == 'query') {
            next('/query')
        } else if((to.path != '/home' && to.path != '/enter' && to.path != '/success') && status == 'open'){
            next('/home')
        } else if(to.path != '/pause' && status == 'close'){
            next('/pause')
        } else {
            next()
        }
    })

    // if (to.path === '/pause') {
    //   next()
    // } else {
    //   next('/pause')
    // }
})


export default router;
